import React from 'react';
import MinimalTile from '../../../../general/MinimalTile';
import styles from './LocalTile.module.scss';

const LocalTile = ({ title, children, leftIcon=null, style=null }) => (
    <MinimalTile title={title} className={styles.tile} leftIcon={leftIcon} style={style}>
        {children}
    </MinimalTile>
)

export default LocalTile;